export default __webpack_public_path__ + "static/media/tt338.a2afd7b6.jpg";